module.exports = __webpack_public_path__ + "static/media/student-study-prev.c65dfa99.png";